import { csiAPI } from "src/boot/axios"
import { CSIurl } from "src/util/enums/urls"
import { concatUrl, getCustomConfig, getNewAbortHandler } from "src/util/http/httpHelper"
import { ObjectList, PayloadEntity } from "src/util/types/dataModels/genericObject"
import { HttpConfig } from "src/util/types/dataModels/http"
import {
  PERMISSION_ACCESS_CREATE,
  PERMISSION_ACCESS_READ,
  PERMISSION_ACCESS_UPDATE,
  PERMISSION_WORK_ORDERS,
} from "src/util/types/dataModels/user"
import {
  WorkOrderPriority,
  WorkOrderPriorityFilterParams,
} from "src/util/types/dataModels/workOrderPriority"

export async function getWorkOrderPrioritiesList(
  config: HttpConfig<WorkOrderPriorityFilterParams> = {}
): Promise<ObjectList<WorkOrderPriority>> {
  const entityURL = CSIurl.WORK_ORDER_PRIORITIES
  const url = concatUrl(entityURL, { ...config?.mainParams, ...config?.filterParams })
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", entityURL)
  const customConfig = getCustomConfig(abortHandler, PERMISSION_WORK_ORDERS, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}

export async function postWorkOrderPriority(
  config: HttpConfig = {},
  priority: PayloadEntity<WorkOrderPriority>
): Promise<WorkOrderPriority> {
  const url = CSIurl.WORK_ORDER_PRIORITIES
  const abortHandler = config?.abortHandler || getNewAbortHandler("POST", url)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_WORK_ORDERS,
    PERMISSION_ACCESS_CREATE
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.post(url, priority, { signal, customConfig })

  return data
}

export async function getWorkOrderPriority(
  config: HttpConfig = {},
  priorityId: string
): Promise<WorkOrderPriority> {
  const url = CSIurl.WORK_ORDER_PRIORITIES_ID.replace("{id}", priorityId)
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", url)
  const customConfig = getCustomConfig(abortHandler, PERMISSION_WORK_ORDERS, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}

export async function putWorkOrderPriority(
  config: HttpConfig = {},
  priorityId: string,
  priority: PayloadEntity<WorkOrderPriority>
): Promise<WorkOrderPriority> {
  const url = CSIurl.WORK_ORDER_PRIORITIES_ID.replace("{id}", priorityId)
  const abortHandler = config?.abortHandler || getNewAbortHandler("PUT", url)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_WORK_ORDERS,
    PERMISSION_ACCESS_UPDATE
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.put(url, priority, { signal, customConfig })

  return data
}

export async function patchWorkOrderPriority(
  config: HttpConfig = {},
  priorityId: string,
  priority: Partial<PayloadEntity<WorkOrderPriority>>
): Promise<WorkOrderPriority> {
  const url = CSIurl.WORK_ORDER_PRIORITIES_ID.replace("{id}", priorityId)
  const abortHandler = config?.abortHandler || getNewAbortHandler("PATCH", url)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_WORK_ORDERS,
    PERMISSION_ACCESS_UPDATE
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.patch(url, priority, { signal, customConfig })

  return data
}
